import { useLocation, withRouter } from "react-router-dom";
import {
  selectRequestData,
  selectRequestState
} from "../../../../store/reducers";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import ErrorPage from "../../../ErrorPage";
import Loader from "../../../../components/Loader";
import actionTypes from "../../../../store/actionTypes";
import { getSalesforceToken } from "../../../../store/actions/salesforce";
import useLoadingState from "../../../../utils/use-loading-state";
import { updateSalesforceConfiguration } from "../../../../store/actions/config";
import { useString as s } from "../../../../components/StringProvider";
import { message } from "antd";

const SalesforceCallback = ({
  history,
  stateData,
  getSalesforceToken,
  salesforceTokenLoadingState,
  salesforceTokens,
  updateSalesforceConfiguration,
  updateConfigurationLoadingState
}) => {
  const [error, setError] = useState(false);
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const code = params.get("code");
  const { baseUrl, clientId, clientSecret } = stateData ? stateData : {};

  const success = s(
    "generalAdmin.page.salesforceConnection.messages.success",
    "Cuvama connected to SalesForce!"
  );

  useEffect(() => {
    if (code && stateData) {
      getSalesforceToken({ baseUrl, clientId, clientSecret, code });
    }
  }, [code, stateData]);

  useLoadingState(
    salesforceTokenLoadingState,
    () => {
      if (salesforceTokens && salesforceTokens.access_token) {
        updateSalesforceConfiguration({
          baseUrl,
          clientId,
          clientSecret,
          accessToken: salesforceTokens.access_token,
          refreshToken: salesforceTokens.refresh_token
        });
      } else {
        setError(true);
      }
    },
    () => {
      setError(true);
    }
  );

  useLoadingState(
    updateConfigurationLoadingState,
    () => {
      message.success(success);
      history.push({
        pathname: "/organizations/general/salesforce-connection"
      });
    },
    () => {
      setError(true);
    }
  );

  return error ? <ErrorPage /> : <Loader />;
};

const mapStateToProps = (state) => {
  return {
    stateData: selectRequestData(state, actionTypes.LOGIN_STATE_SUCCESS),
    salesforceTokenLoadingState: selectRequestState(
      state,
      actionTypes.SALESFORCE_TOKEN_REQUEST
    ),
    salesforceTokens: selectRequestData(
      state,
      actionTypes.SALESFORCE_TOKEN_REQUEST
    ),
    updateConfigurationLoadingState: selectRequestState(
      state,
      actionTypes.UPDATE_SALESFORCE_CONFIGURATION_REQUEST
    )
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalesforceToken,
      updateSalesforceConfiguration
    },
    dispatch
  );

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SalesforceCallback);
